export default "/images/vendor/@coreui/icons/svg/flag/cif-kr.svg?ef3dcf8352ba146b1a122786c1893304";